import type { Release } from '../releases';

export default {
  id: '2026-11-01-contract-deliveries-by-item',
  at: '2026-11-01T11:03:00Z',
  title: 'Поставки по договору — по позициям спецификации',
  modules: ['contracts', 'warehouse'],
  items: [
    'В графике договора у строки «поставка» выбирается позиция спецификации. Приход на склад закрывает строку своей позиции: привезли всю трубу — закрыта строка трубы, даже если насосы ещё в пути.',
    'Несколько поставок одной позиции закрываются по очереди, по плановой дате. Сторно прихода снимает отметку обратно.',
    'В карточке договора у поставки видно позицию и состояние: «поставлено», «ждём поставку» или «поставка просрочена».',
    'При замене спецификации и в допсоглашении привязка строк к позициям сохраняется; у подписанного договора позицию строки ставит допсоглашение.',
  ],
  why: 'Раньше строки поставки закрывались по средней доле всего договора: полностью привезённая позиция могла остаться «не поставленной», а частичный приход закрывал чужую строку.',
  link: '/contracts',
} satisfies Release;
